import { apiFetch } from './api';

export function getParametresDevis() {
  return apiFetch('/parametres-devis');
}

export function updateParametresDevis(data) {
  return apiFetch('/parametres-devis', { method: 'PUT', body: JSON.stringify(data) });
}

/**
 * Efface toutes les demandes de devis et ce qui en découle (devis, contrats,
 * planification, documents, émargements, pièces). `confirmation` doit valoir
 * « SUPPRIMER » : le serveur refuse sans.
 */
export function reinitialiserDemandes(confirmation) {
  return apiFetch('/parametres-devis/reinitialiser-demandes', {
    method: 'POST',
    body: JSON.stringify({ confirmation }),
  });
}
